import {prioridadePAE, VisitaVo} from '~model/vo/visita-vo';

export const onlyHour = (time: string | undefined) => {
  if (time) {
    const split = time.split(' ');
    if (split.length === 2) {
      return split[1];
    }
  }
  return '';
};

export const onlyDays = (time: string | undefined) => {
  if (time) {
    const split = time.split(' ');
    if (split.length === 2) {
      return split[0];
    }
  }
  return '';
};

export const toNumber = (hour: string | undefined, precision?: number | undefined) => {
  if (!hour) {
    return 0;
  }
  const split = hour.replace(':', '.').split('d ');
  const dias = split.length > 1 ? Number(split[0]) : 0;
  const val = parseFloat(split.length > 1 ? split[1] : split[0]);
  const horas = (dias * 24) + Math.floor(val) + (val - Math.floor(val)) * 10 / 6;
  return Number(horas.toFixed(precision || 3));
};

const round = (v: number, middleUp?: boolean) => {
  const val = Math.abs(v);
  const floor = Math.floor(val);
  if (middleUp) {
    return (val - floor) * 10 <= 5 ? Math.floor(Math.abs(v)) : floor + 1;
  }
  return floor;
};

export const toHour = (hour: number, zeroValue?: boolean) => {
  if (!hour && !zeroValue) {
    return '';
  }
  const format = (v: number) => v < 10 ? '0' + v : v;
  const dias = round(hour / 24);
  const diasStr = dias ? dias + 'd ' : '';
  const horas = round(hour % 24);
  const minutos = round((hour - Math.floor(hour)) * 60, true);
  return `${diasStr}${format(horas)}:${format(minutos)}`;
};

export function formatSeconds(floatSegundos: number, hasHour?: boolean): string {
  if (!floatSegundos && !hasHour) {
    return '00:00';
  } else if (!floatSegundos && hasHour) {
    return '00:00:00';
  }

  const format = (v: number) => v < 10 ? '0' + v : v;
  const horas = round(floatSegundos / 3600);
  const minutos = (round(floatSegundos / 60)) - (horas * 60);
  const segundos = (round(floatSegundos)) - (minutos * 60) - (horas * 3600);


  return (horas === 0 ? '' : format(horas) + ':') + format(minutos) + ':' + format(segundos);
}

export const diffTime = (planejado: string, executado: string) => {
  const plan = toNumber(planejado);
  const exec = executado && toNumber(executado) || undefined;
  if (exec === undefined) {
    return '';
  }
  const diff = ((exec * 1000) - (plan * 1000)) / 1000;
  const time = toHour(Math.abs(diff), true);
  const sinal = time ? (diff < 0 ? '-' : '+') : '';
  return `${sinal}${time}`;
};

export const outsideWindow = (visit: VisitaVo): boolean => {
  const chegada = toNumber(prioridadePAE(visit.chegada) ?? 0) % 24;
  const inicioJanela = toNumber(visit.janelaInicio) % 24;
  const fimJanela = toNumber(visit.janelaFim) % 24;

  return chegada > fimJanela || chegada < inicioJanela;
};
